import React from 'react';
import { MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { cx } from '../../../customEmotion';
import { useMUITheme } from '../../styles/theme';
import Checkbox from '../../Checkbox';
import { OptionData } from './NestedAccordionSelectGroup';

interface NestedAccordionSelectItemProps {
  option: OptionData;
  handleChangeValue: (value: string) => void;
  selectedValue: string[];
  isMainOption?: boolean;
}

export const useCustomStyle = makeStyles(theme => ({
  container: {
    padding: '8px 8px 8px 24px',
    backgroundColor: theme.palette.common.white,

    '&:hover': {
      backgroundColor: theme.palette.primary.lightest,
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    },

    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.lightest,
      '& > div': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
      },
    },
  },
  checkbox: {
    padding: 0,
    color: theme.palette.grey['A400'],
    width: '32px',
    height: '32px',
    alignSelf: 'center',

    '&:hover': {
      backgroundColor: 'none',
    },

    '& .MuiSvgIcon-root': {
      width: '16px',
      height: '16px',
    },

    '&.MuiCheckbox-indeterminate': {
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
    },
  },
  greyBlock: {
    minHeight: '30px',
    padding: '4px 8px',
    color: theme.palette.grey[600],
    backgroundColor: theme.palette.grey[100],
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '21px',
    borderRadius: '4px',
    alignSelf: 'center',
    whiteSpace: 'pre-wrap',
  },
}));

/**
 * TODO: 本 component 疑似無用處？
 */
const NestedAccordionSelectItem: React.FC<NestedAccordionSelectItemProps> = ({
  option,
  handleChangeValue,
  selectedValue,
}) => {
  // TODO: 確認沒有顯示出來
  console.log('&&&&&& NestedAccordionSelectItem');
  const theme = useMUITheme();
  const customOptionStyle = useCustomStyle(theme);

  const handleClick = () => {
    handleChangeValue(option.value);
  };

  return (
    <MenuItem
      className={cx(customOptionStyle.container, {
        ['Mui-selected']: selectedValue.includes(option.value),
      })}
      value={option.value}
      onClick={handleClick}
    >
      <Checkbox
        color="primary"
        checked={selectedValue.includes(option.value)}
        className={customOptionStyle.checkbox}
        indeterminate={selectedValue.length > 0 && !selectedValue.includes(option.value)}
      />
      <div className={customOptionStyle.greyBlock}>{option.text}</div>
    </MenuItem>
  );
};

export default NestedAccordionSelectItem;
